
import { useQuery } from "@tanstack/react-query";
import { db } from "@/lib/db";
import { Era, SocialClass } from "@/types/investigator";
import { occupationMatchesClass } from "@/utils/gaslight-skill-filter";
import { getEraTable } from "@/utils/era-tables";
import { getEraConfig } from "@/config/era-registry";


export const useOccupations = (era: Era = '1920s', socialClass?: SocialClass) => {
  return useQuery({
    queryKey: ["occupations", era, socialClass],
    queryFn: async () => {
      try {
        const table = getEraTable(era, 'occupations');
        const eraConfig = getEraConfig(era);
        const { data, error } = await db
          .from(table)
          .select('*')
          .order('Occupation');

        if (error || !data || data.length === 0) {
          return eraConfig.fallbackOccupations;
        }

        let filtered = data;
        if (era === 'gaslight' && socialClass) {
          filtered = data.filter(item => {
            const cr = item["Credit Rating"] as string;
            return occupationMatchesClass(cr || '', socialClass);
          });
        }
        if (era === 'regency' && socialClass) {
          // socialClass is repurposed as occupational band string for regency
          const band = parseInt(socialClass);
          if (!isNaN(band)) {
            filtered = data.filter(item => item["Occupational Band"] === band);
          }
        }
        if (era === 'darkages' && socialClass) {
          // socialClass is repurposed as social-standing band string for the Dark Ages
          const band = parseInt(socialClass);
          if (!isNaN(band)) {
            filtered = data.filter(item => item["Occupational Band"] === band);
          }
        }
        if (era === 'invictus' && socialClass) {
          // socialClass is repurposed as Roman social-band string for Invictus
          const band = parseInt(socialClass);
          if (!isNaN(band)) {
            filtered = data.filter(item => item["Occupational Band"] === band);
          }
        }

        return filtered.map(item => item.Occupation as string);
      } catch (e) {
        console.error("Exception in useOccupations:", e);
        return getEraConfig(era).fallbackOccupations;
      }
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
  });
};
